import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

import BaseCard from '@ui/atoms/BaseCard';
import BasicText from '@ui/atoms/BasicText';
import FlexRow from '@ui/atoms/FlexRow';

import { ColorTypes } from '@folx-types/theme';

import theme from '@theme/FolxTheme';

const IconCard = styled(BaseCard)`
	padding: ${theme.spacing.xs} ${theme.spacing.md};
`;

export interface IMessageIconCardProps {
	bgColor: ColorTypes;
	Icon: ReactNode;
	iconAlt: string;
	message: string;
}

const MessageIconCard: FC<IMessageIconCardProps> = ({ bgColor, Icon, iconAlt, message }) => {
	return (
		<IconCard radius="md" bgColor={bgColor} borderless>
			<FlexRow gap="xs">
				<Icon
					height={theme.spacing.sm}
					width={theme.spacing.sm}
					aria-label={iconAlt}
					style={{ flexShrink: 0 }}
				/>
				<BasicText variant="fineprint">{message}</BasicText>
			</FlexRow>
		</IconCard>
	);
};

export default styled(MessageIconCard)``;
